import React, { useMemo } from "react";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../../modules/login";
import styled, { withTheme } from "styled-components";
import ProfileCard from "../../../components/ui-library/ProfileCard/ProfileCard";
import SmartPageHeader from "../../../components/smart/PageHeader/PageHeader";
import CaregiversTable from "../../../components/smart/CaregiversTable/CaregiversTable";

const ProfileCardsWrapper = styled.div``;

const ParticipantCaregivers = (props) => {
  const {
    route,
    studies,
    match: {
      params: { participantUsername, participantId },
    },
  } = props;

  const studyCode = useMemo(
    () =>
      studies?.find(
        (o) => o?.studyId?.toLowerCase() === route?.study?.toLowerCase()
      )?.code ?? "",
    [studies, route]
  );

  const participant = useMemo(
    () => ({ participantId: participantId, userName: participantUsername }),
    [participantUsername, participantId]
  );

  return (
    <>
      <SmartPageHeader
        studyId={route.study}
        title={studyCode}
        participantId={participantId}
        shouldFetchParticipant={true}
      />

      <ProfileCardsWrapper>
        <ProfileCard
          title={`${participant.userName}'s caregivers`}
          showIcon={false}
        >
          <CaregiversTable studyId={route.study} participant={participant} />
        </ProfileCard>
      </ProfileCardsWrapper>
    </>
  );
};

export default connect((state) => {
  return {
    ...mapStateToPropsLogin(state),
    userData: state?.smartPageHeaderReducer,
    loginReducer: state?.loginReducer,
  };
})(withTheme(ParticipantCaregivers));
